import { Card, CardContent } from '@estac1/ui';
import type { ClientOverview } from './types.js';

/**
 * O estacionamento no mapa (#656), pelo embed do OpenStreetMap: sem chave e
 * sem biblioteca. Com só a cidade achada, o zoom abre e a legenda avisa.
 */
export const LotMap = ({ location }: { location: ClientOverview['location'] }) => {
  if (!location) {
    return (
      <Card>
        <CardContent className="py-6 text-sm text-muted-fg">
          Endereço sem localização no mapa.
        </CardContent>
      </Card>
    );
  }
  const d = location.precision === 'address' ? 0.004 : 0.06;
  const { lat, lng } = location;
  const embed = `https://www.openstreetmap.org/export/embed.html?bbox=${lng - d},${lat - d},${lng + d},${lat + d}&layer=mapnik&marker=${lat},${lng}`;
  const zoom = location.precision === 'address' ? 17 : 12;
  return (
    <Card className="overflow-hidden">
      <iframe
        title="Mapa do estacionamento"
        src={embed}
        className="aspect-[16/9] w-full border-0"
        loading="lazy"
      />
      <CardContent className="flex items-center justify-between gap-2 py-2 text-xs text-muted-fg">
        <span>
          {location.precision === 'address' ? 'No endereço cadastrado' : 'Só a cidade foi achada'}
        </span>
        <a
          className="font-medium text-fg underline"
          href={`https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=${zoom}/${lat}/${lng}`}
          target="_blank"
          rel="noreferrer"
        >
          Abrir no mapa
        </a>
      </CardContent>
    </Card>
  );
};
